<script>
import { Bar } from 'vue-chartjs'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'

export default {
  extends: Bar,
  props: {
    visitData: {
      type: Array,
      default: null
    },
    labels: {
      type: Array,
      default: null
    },
    periodType: {
      type: String,
      default: null
    }
  },
  data() {
    return {
    
      options: {
        responsive: true,
        scales: {
                    yAxes: [{
                        ticks: {
                            min: 0,
                            beginAtZero: true
                        }
                    }]
                }
        
      }
    }
  },
  methods: {

   
  },
  
  
  mounted () {
    let datacollection = {
      labels: this.labels,
      datasets: [
        {
          label: this.periodType + ' Total Visitors',
          backgroundColor: '#f87979',
          data: this.visitData
        }
      ]
    }
    this.renderChart(datacollection, this.options)
  
   
  }
}
</script>
